import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import InstallAppGuide from '../../components/smartfacture/InstallAppGuide';

const MobileAppPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        {/* Back button */}
        <Link to="/dashboard/smartfacture">
          <Button variant="ghost" className="mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour au dashboard
          </Button>
        </Link>

        {/* Install Guide */}
        <InstallAppGuide />

        {/* Video tutorial placeholder */}
        <div className="mt-6 bg-white rounded-2xl border p-6 text-center">
          <h3 className="font-semibold text-slate-900 mb-2">Besoin d'aide ?</h3>
          <p className="text-slate-500 mb-4">
            Notre équipe support est disponible pour vous aider à installer l'application.
          </p>
          <div className="flex gap-3 justify-center">
            <Link to="/dashboard/smartfacture/support">
              <Button variant="outline">
                Contacter le support
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppPage;
